export default __webpack_public_path__ + "static/3-72e6a5b7b06da3b879b6e9aa62260aa1.png";